import './HeatmapLoader.scss';

export const HeatmapLoader = () => (
  <div style={loaderWrapperStyle}>
    <div style={dotStyle}></div>
    <style>{keyframes}</style>
  </div>
);

const loaderWrapperStyle: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '200px',
};

const dotStyle: React.CSSProperties = {
  width: '100px',
  height: '100px',
  borderRadius: '50%',
  background: `
    radial-gradient(
      circle,
      rgba(255, 0, 0, 0.9) 0%,
      rgba(255, 165, 0, 0.6) 25%,
      rgba(255, 255, 0, 0.4) 50%,
      rgba(0, 255, 0, 0.3) 70%,
      rgba(0, 255, 255, 0.2) 90%
    )
  `,
  animation: 'pulse-heat 1.8s infinite ease-in-out',
  filter: 'blur(1px)',
};

const keyframes = `
@keyframes pulse-heat {
  0% {
    transform: scale(1);
    opacity: 0.7;
  }
  50% {
    transform: scale(1.5);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0.7;
  }
}
`;


export default HeatmapLoader;
